<section id="introArticleDetails" [ngStyle]="{'background-image': 'url('+video.imageUrl+')'}">
  <div class="half-black">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="display-4" >{{video.title}}</h1>
          <h6 class="text-white"><time itemprop="datePublished" datetime pubdate>{{video.date | date: "MMM d, yyyy"}}</time></h6>
          <h6 class="text-white">Views: {{video.views|number:'1.0-0'}}</h6>

        </div>

      </div>
    </div>
  </div>
</section>

<section id="mainVideo">
  <main role="main" class="container">
    <div class="row">
      <div class="col-md-8 blog-main">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/videos">Videos</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{video.title}}</li>
          </ol>
        </nav>

        <div class="blog-post">
          @if (video) {
            <div>
              @if (video.video) {
                <div>
                  <iframe width="560" height="315" [src]="'//www.youtube-nocookie.com/embed/'+video.video+'?rel=0&hd=1&showinfo=0&modestbranding=1&autohide=1&wmode=transparent&origin=https://www.investingforcatholics.com' | safe: 'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              }
              <!-- <div [innerHTML]="video.content | safe:'html'"></div>  -->
              <div [innerHTML]="video.content | safe:'html'"></div>
              <!-- <p><small>All videos are being provided for informational purposes only and should not be considered a solicitation, recommendation, or endorsement of any particular security, product or service, or considered to be investment or tax advice. There is no guarantee any investment strategies will be successful.  Investing involves risks, including possible loss of principal. Past performance does not guarantee future returns. No investment decisions should be made solely based on the information in any of these videos.  The opinions referenced within are as of the date of each video recording and are subject to change without notice. Information provided by third-party sources is not endorsed or guaranteed by IFA. Please be sure to use the pause button to fully read the important disclosures at the end of each video.</small></p> -->
            </div>
          }
        </div><!-- /.blog-post -->


      </div><!-- /.blog-main -->

      <aside class="col-md-4 blog-sidebar">
        <img class="card-img-right flex-auto d-md-block img-fluid" src="{{video.imageUrl}}" width="350"
          alt="">
          <div class="p-3 mb-3 bg-light rounded">
            <h4>Video By</h4>
            <p class="mb-0">{{video.author}} <br />Views: {{video.views|number:'1.0-0'}}<br /> </p>
          </div>

          <div class="p-3 social-icons">
            <h4>Share</h4>
            <ul class="">
              <li (click)="socialsharefacebook()" class="social-share facebook"><i><app-facebook></app-facebook></i></li>
              <li (click)="socialsharetwitter()" class="social-share twitter"><i><app-twitter></app-twitter></i></li>
              <li (click)="socialsharelinkedin()" class="social-share linkedin"><i><app-linkedin></app-linkedin></i></li>
              <li (click)="emailCurrentPage()" class="social-share email"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x"></fa-icon></i></li>
            </ul>
          </div>

          <div class="p-3">
            <h4>Other Videos</h4>
            <ol class="list-unstyled mb-0">
              @for (v of videos; track v; let x = $index) {
                <div>
                  @if (x < 3) {
                    <div>
                      <!-- {{v|json}} -->
                      <app-similar-videos [data]="v"></app-similar-videos>
                    </div>
                  }
                </div>
              }
            </ol>
          </div>

        </aside><!-- /.blog-sidebar -->

      </div><!-- /.row -->

    </main>
  </section>

